import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'
import SharedSections from './SharedSections'

const Article = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Image' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`article-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Name'>
        <Textfield
          placeholder='Name'
          name='name'
          value={content.name || ''}
          onChange={onChange('name')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Subtitle'>
        <Textfield
          placeholder='Subtitle'
          name='subtitle'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Description'>
        <Textfield
          placeholder='Description'
          name='description'
          value={content.description || ''}
          onChange={onChange('description')}
          disabled={disabled}
          multiLine
        />
      </FieldLabel>
      <FieldLabel label='Button Label'>
        <Textfield
          placeholder='Button Label'
          name='buttonText'
          value={content.buttonText || ''}
          onChange={onChange('buttonText')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Article', content: Article }, ...SharedSections]
